export const REVIEW_TAB = "review";
export const RUNS_TAB = "runs";
export const PROMPTS_TAB = "prompts";
export const SETTINGS_TAB = "settings";
export const OPENAI_LATEST_MODEL_KEY = "gpt-5.5";

export const AI_TABS = [
  { id: REVIEW_TAB, label: "Review", icon: "mdi-clipboard-text-search-outline" },
  { id: RUNS_TAB, label: "Runs", icon: "mdi-timeline-clock-outline" },
  { id: PROMPTS_TAB, label: "Prompts", icon: "mdi-text-box-edit-outline" },
  { id: SETTINGS_TAB, label: "Settings", icon: "mdi-tune-vertical-variant" },
];

export const REVIEW_STATUS_OPTIONS = [
  { label: "Toate", value: "" },
  { label: "Pending review", value: "pending_review" },
  { label: "Ready to apply", value: "ready_to_apply" },
  { label: "Applied", value: "applied" },
  { label: "Rejected", value: "rejected" },
  { label: "Recomputing", value: "recomputing" },
];

export const ENTITY_TYPE_OPTIONS = [
  { label: "Toate", value: "" },
  { label: "Company", value: "company" },
  { label: "Person", value: "person" },
  { label: "Lead", value: "lead" },
];

export const PROVIDER_STATUS_OPTIONS = [
  { label: "Activ", value: "active" },
  { label: "Inactiv", value: "inactive" },
];

export const SYNC_MODE_OPTIONS = [
  { label: "Sync", value: "sync" },
  { label: "Async", value: "async" },
];

export const REASONING_OPTIONS = [
  { label: "Minimal", value: "minimal" },
  { label: "None", value: "none" },
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "XHigh", value: "xhigh" },
];

export const RUN_RETRYABLE_STATUSES = ["failed", "succeeded"];

export const parseJsonEditorValue = (value) => {
  const normalized = String(value ?? "").trim();
  if (!normalized) {
    return "";
  }
  try {
    return JSON.parse(normalized);
  } catch (_) {
    return normalized;
  }
};

export const formatJsonBlock = (value) => {
  if (!value) {
    return "—";
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch (_) {
    return String(value);
  }
};

export const formatValueBlock = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  if (typeof value === "object") {
    return JSON.stringify(value, null, 2);
  }
  return String(value);
};

export const formatEntityLabel = (entityType, entityId) =>
  `${String(entityType || "entity").toUpperCase()} #${entityId || "?"}`;

export const formatReviewStatus = (value) => ({
  pending_review: "Pending review",
  ready_to_apply: "Ready to apply",
  applied: "Applied",
  rejected: "Rejected",
  recomputing: "Recomputing",
}[value] || value || "unknown");

export const reviewStatusColor = (value) => ({
  pending_review: "warning",
  ready_to_apply: "primary",
  applied: "success",
  rejected: "error",
  recomputing: "info",
}[value] || "grey");

export const formatSuggestionStatus = (value) => ({
  pending: "Pending",
  approved: "Approved",
  edited: "Edited",
  rejected: "Rejected",
  applied: "Applied",
  not_applicable: "Not applicable",
}[value] || value || "unknown");

export const suggestionStatusColor = (value) => ({
  pending: "warning",
  approved: "primary",
  edited: "secondary",
  rejected: "error",
  applied: "success",
  not_applicable: "grey",
}[value] || "grey");

export const formatConfidence = (value) => `${Math.round(Number(value || 0) * 100)}%`;

export const formatRunStatus = (value) => ({
  queued: "Queued",
  running: "Running",
  retrying: "Retrying",
  failed: "Failed",
  succeeded: "Succeeded",
}[value] || value || "unknown");

export const runStatusColor = (value) => ({
  queued: "warning",
  running: "info",
  retrying: "secondary",
  failed: "error",
  succeeded: "success",
}[value] || "grey");

export const providerStatusColor = (status) => (status === "active" ? "success" : "grey");

export const isOpenAiProviderKey = (providerKey) => String(providerKey || "").trim().toLowerCase() === "openai";

export const resolveProfileModelKey = (profile = {}) => {
  if (profile.model_key) {
    return profile.model_key;
  }
  return isOpenAiProviderKey(profile.provider_key) ? OPENAI_LATEST_MODEL_KEY : "";
};

export const buildProviderDrafts = (providers = []) =>
  providers.reduce((acc, provider) => {
    acc[provider.provider_key] = {
      label: provider.label || "",
      apiKey: "",
      status: provider.status || "inactive",
    };
    return acc;
  }, {});

export const buildProfileDrafts = (profiles = []) =>
  profiles.reduce((acc, profile) => {
    acc[profile.profile_key] = {
      provider_key: profile.provider_key,
      model_key: resolveProfileModelKey(profile),
      sync_mode: profile.sync_mode,
      reasoning_effort: profile.reasoning_effort,
      is_active: Boolean(profile.is_active),
    };
    return acc;
  }, {});
